// extracted by mini-css-extract-plugin
export default {"todoEntry":"todoEntry--dBJpC","todoIcon":"todoIcon--Avh8k","todoIconActive":"todoIconActive--o8Gzg"};